/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//English (United Kingdom)
export default {
  'ai-mate.chat-error-banner.description': 'Your chat history is saved up to 30 days.',
  'ai-mate.chat-error-banner.title': 'Start new chat',
  'ai-mate.chat-error.description': 'Try <btn>reloading chat</btn>.',
  'ai-mate.chat-error.rate-limited-description':
    'You have reached the maximum number of requests. Please try again later.',
  'ai-mate.chat-error.rate-limited-title': 'Too many requests',
  'ai-mate.chat-error.rovo-inactive-description':
    "Looks like Rovo isn't enabled on your site. <link>Setting up Rovo</link>",
  'ai-mate.chat-error.rovo-inactive-title': 'Rovo is inactive',
  'ai-mate.chat-error.title': "We're not sure what went wrong",
  'ai-mate.chat-input.file-close-icon-label': 'Remove file',
  'ai-mate.chat-input.file-error-icon-label': 'Error loading file',
  'ai-mate.chat-view.chat-item.chat-delete-label': 'Delete',
  'ai-mate.chat-view.chat-item.chat-options-for-conversation-button-label': 'Chat options for {conversationName}',
  'ai-mate.chat-view.chat-item.chat-rename-label': 'Rename',
  'ai-mate.common.ui.expandable-section.collapse': 'Collapse',
  'ai-mate.common.ui.expandable-section.expand': 'Expand',
  'ai-mate.conversation-assistant-page-selector.page-selector-label': 'Select page',
  'ai-mate.conversation-assistant-space-selector.space-selector-label': 'Select space',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.cancel-button-label.non-final': 'Cancel',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.conversation-not-found-failure-message.non-final':
    'The conversation you are trying to delete does not exist.',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.delete-button-label.non-final': 'Delete',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.delete-conversation-title.non-final':
    'Delete Conversation "{name}"?',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.generic-failure-message.non-final':
    'An error occurred while deleting the conversation. Please try again.',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.modal-body.non-final':
    'Are you sure you want to delete this conversation? This action cannot be undone.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.cancel-button-label.non-final': 'Cancel',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.channel-not-found-error-message.non-final':
    'The channel you are trying to edit does not exist.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.edit-name-label.non-final': 'Name',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.generic-error-message.non-final':
    'An error occurred while editing the conversation. Please try again.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.modal-title.non-final': 'Edit Conversation',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.name-is-same-error-message.non-final':
    'The name is the same as the current name.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.save-button-label.non-final': 'Save',
  'ai-mate.conversation-list-view.accessible-search-results':
    '{results, plural, =1 {1 result found} other {# results found}}',
  'ai-mate.conversation-list-view.back-button.label': 'Back',
  'ai-mate.conversation-list-view.close-chat-button.label': 'Close chat',
  'ai-mate.conversation-list-view.header-title': 'Chat History',
  'ai-mate.conversation-list-view.new-chat-button.label': 'New chat',
  'ai-mate.conversation-list-view.no-chat': 'No results',
  'ai-mate.conversation-list-view.search-input.placeholder': 'Search chats',
  'ai-mate.expander.hide-details': 'Hide details',
  'ai-mate.expander.show-details': 'Show more details',
  'ai-mate.main-chat.close-chat-panel-button-label': 'Close chat',
  'ai-mate.main-chat.hamburger-menu-label': 'Menu',
  'ai-mate.main-chat.maximize-chat-button-label': 'Full screen',
  'ai-mate.main-chat.minimize-chat-button-label': 'Restore view',
  'ai-mate.main-chat.new-chat-button-label': 'New',
  'ai-mate.main-chat.new-chat-button-label-full-screen': 'New chat',
  'ai-mate.rovo-chat-header.back-button-label': 'Back',
  'ai-mate.rovo-chat-header.close-chat-header-button-label': 'Close',
  'ai-mate.rovo-chat-header.debug-button-label': 'Debug',
  'ai-mate.rovo-chat-header.delete-button-text': 'Delete',
  'ai-mate.rovo-chat-header.delete-icon-label': 'Delete',
  'ai-mate.rovo-chat-header.feedback-button-text': 'Feedback',
  'ai-mate.rovo-chat-header.feedback-icon-label': 'Feedback',
  'ai-mate.rovo-chat-header.floating-button-text': 'Floating',
  'ai-mate.rovo-chat-header.floating-icon-label': 'Floating',
  'ai-mate.rovo-chat-header.fullscreen-button-text': 'Full screen',
  'ai-mate.rovo-chat-header.fullscreen-icon-label': 'Full screen',
  'ai-mate.rovo-chat-header.get-help-button-text': 'Get help',
  'ai-mate.rovo-chat-header.get-help-icon-label': 'Get help',
  'ai-mate.rovo-chat-header.menu-button-label': 'Menu',
  'ai-mate.rovo-chat-header.more-menu-button-label': 'More',
  'ai-mate.rovo-chat-header.more-menu-open-in-section-text': 'Open in...',
  'ai-mate.rovo-chat-header.new-agent-chat-button-label': 'New chat with {agentName}',
  'ai-mate.rovo-chat-header.new-chat-button-label': 'New chat',
  'ai-mate.rovo-chat-header.rename-button-text': 'Rename',
  'ai-mate.rovo-chat-header.rename-icon-label': 'Rename',
  'ai-mate.rovo-chat-header.sidebar-button-text': 'Sidebar',
  'ai-mate.rovo-chat-header.sidebar-icon-label': 'Sidebar',
  'conversation-assistant-button.rovo-chat-label': 'Rovo Chat',
  'highlight-actions.rovo-chat-custom-prompt-submit-button.text': 'Send',
  'highlight-actions.rovo-chat-custom-prompt.placeholder': 'Ask AI about this',
  'highlight-actions.rovo-chat-explain-option.text': 'Explain',
  'highlight-actions.rovo-chat-explain-prompt':
    'Explain this by rephrasing it and adding additional detail, but use very simple language, short sentences, and provide examples or definitions to any technical terminology used in the original phrasing.',
  'highlight-actions.rovo-chat-find-resources-option.text': 'Find resources',
  'highlight-actions.rovo-chat-find-resources-prompt':
    'Find resources within organisational knowledge only that supports the statements made.',
  'highlight-actions.rovo-chat-give-examples-option.text': 'Give examples',
  'highlight-actions.rovo-chat-give-examples-prompt':
    'Give examples of this from organisational resources or public knowledge. If there are no resources to provide attempt to give a metaphorical example that may help someone understand this more.',
  'highlight-actions.rovo-chat-give-feedback-option.text': 'Give feedback',
  'highlight-actions.rovo-chat-give-feedback-prompt':
    'Give feedback by reviewing the phrasing of this. Provide commentary on word choice, grammar, punctuation. Be positive and enthusiastic but always provide at least one thing to improve or change.',
  'highlight-actions.rovo-chat-more-options.tooltip': 'Chat recommendations',
  'highlight-actions.rovo-chat-open-chat.tooltip': 'Open Chat',
  'highlight-actions.rovo-chat-summarize-option.text': 'Summarise',
  'highlight-actions.rovo-chat-summarize-prompt':
    'Highlight the key points from this. Focus on essential information and exclude unnecessary details. Provide a concise overview in a single paragraph.',
  'highlight-actions.rovo-chat.ask-in-chat-button-text': 'Ask in Chat',
  'highlight-actions.rovo-chat.placeholder-prompt': 'Ask a question about this.',
  'horizontal-scroll-container.scroll-left': 'Scroll left',
  'horizontal-scroll-container.scroll-right': 'Scroll right',
  'rovo-chat.deep-research-spotlight.description':
    'Turn on Deep Research and enter a prompt. Rovo will create a plan, conduct the research, and generate a full report.',
  'rovo-chat.deep-research-spotlight.dismiss': 'Dismiss',
  'rovo-chat.deep-research-spotlight.heading': 'Introducing Deep Research in Rovo',
  'rovo-chat.file-upload-dropzone.drag-drop-message': 'Drag and drop to add context',
  'rovo-chat.message-file.icon-label': 'File',
  'rovo-chat.rovo-greeting.deep-research-greeting-text': "Let's go in-depth",
  'rovo-chat.rovo-greeting.default-greeting-text': 'How can I help, {name}?',
  'rovo-chat.search-input.screen-reader-prompt':
    'Typing any character in this field will update the search results below',
};
